import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface SidebarState {
  /** Whether the sidebar is collapsed (desktop) */
  isCollapsed: boolean;
  /** Whether the mobile sidebar overlay is open */
  isMobileOpen: boolean;
  /** Toggle collapsed state */
  toggle: () => void;
  /** Collapse the sidebar */
  collapse: () => void;
  /** Expand the sidebar */
  expand: () => void;
  /** Open mobile sidebar overlay */
  openMobile: () => void;
  /** Close mobile sidebar overlay */
  closeMobile: () => void;
  /** Toggle mobile sidebar overlay */
  toggleMobile: () => void;
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    (set) => ({
      isCollapsed: false,
      isMobileOpen: false,
      toggle: () => set((state) => ({ isCollapsed: !state.isCollapsed })),
      collapse: () => set({ isCollapsed: true }),
      expand: () => set({ isCollapsed: false }),
      openMobile: () => set({ isMobileOpen: true }),
      closeMobile: () => set({ isMobileOpen: false }),
      toggleMobile: () => set((state) => ({ isMobileOpen: !state.isMobileOpen })),
    }),
    {
      name: 'mellify-sidebar',
      partialize: (state) => ({ isCollapsed: state.isCollapsed }),
    }
  )
);